import React from "react";
import Header9 from "./../Common/Header9";
import Footer from "./../Common/Footer";
import Banner from "./../Elements/Banner";
import { NavLink } from "react-router-dom";
var bnrimg = require("../../images/banner/banner.jpg");

class TeamDetail extends React.Component {
  render() {
    return (
      <>
        <Header9 />
        <div className="page-content">
          <Banner title="Mon Compte" pagename="Mon Compte" bgimage={bnrimg} />{" "}
          {/* ABOUT TEAM MEMBER SECTION START */}
          <div className="account section-full p-tb80 mobile-page-padding">
            <div className="container">
              <div className="section-content ">
                <div className="about-team-member text-black">
                  <div className="row">
                    <div className="col-lg-4 col-md-5 col-sm-12">
                      <div className="about-single-team-info-left p-a30 sx-bg-secondry">
                        <div className="profile-image">
                          <img
                            src="https://i.stack.imgur.com/l60Hf.png"
                            alt=""
                          />
                        </div>
                        <div className="text-white text-center p-a30">
                          <h4 className="m-t0">Youssef Ait Bamouh</h4>
                          <h5 className="m-b0">Ingenieur | LYTON</h5>
                        </div>
                        <div className="team-single-social m-t10 text-white">
                          <ul className="m-b0 list-unstyled">
                            <li>
                              <span>
                                <i className="fa fa-envelope" />
                              </span>
                              <span>youssef.aibamouh@gmail.com</span>
                            </li>
                            <li>
                              <span>
                                <i className="fa fa-phone" />
                              </span>
                              <span>(+212) 0691739038</span>
                            </li>
                            <li>
                              <span>
                                <i className="fa fa-map-marker" />
                              </span>
                              <span>157 B6 Riad, Rabat, 16000, Maroc</span>
                            </li>
                            {/* <li>
                              <span>
                                <i className="fa fa-globe" />
                              </span>
                              <span>www.7xtheme-site.com</span>
                            </li> */}
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-8 col-md-7 col-sm-12">
                      <div className="about-single-team-info">
                        <div className="our-exp p-b30">
                          <div className="d-flex">
                            <div className="sx-box">
                              <h3 className="m-t0 m-b10">
                                Informations générales
                              </h3>
                            </div>
                            <a
                              href={"/account/edit"}
                              className="get-in-touch-btn edit-btn from-top"
                            >
                              <i className="fa fa-pencil-square-o" />
                              <span className="ml-2">Modifier</span>
                            </a>
                          </div>
                          {/* <p>Les informations peuvent être modifiées....</p> */}
                          <div className="your-order-list p-a30">
                            <ul>
                              <li>
                                <b> Nom Complet</b>
                                <strong className="pull-right">
                                  Youssef Ait Bamouh
                                </strong>
                              </li>
                              <li>
                                <b> Email </b>
                                <strong className="pull-right">
                                  youssef.aitbmamouh@um6p.ma
                                </strong>
                              </li>
                              <li>
                                <b> Fonction</b>
                                <strong className="pull-right">
                                  Ingenieur
                                </strong>
                              </li>
                              <li>
                                <b>Organisme</b>
                                <strong className="pull-right">LYTON</strong>
                              </li>
                              <li>
                                <b> CNIE </b>
                                <strong className="pull-right">GK77098</strong>
                              </li>
                              <li>
                                <b> Etat Civil </b>
                                <strong className="pull-right">Exemple</strong>
                              </li>
                              <li>
                                <b> Téléphone </b>
                                <strong className="pull-right">
                                  (+212) 0622435598
                                </strong>
                              </li>
                              <li>
                                <b> Date de Naissance </b>
                                <strong className="pull-right">
                                  May 17, 1990
                                </strong>
                              </li>
                              <li>
                                <b> Situation Familiale </b>
                                <strong className="pull-right">
                                  Marié Avec Enfants
                                </strong>
                              </li>
                              <li>
                                <b> Nombre d'enfant(s) </b>
                                <strong className="pull-right">2</strong>
                              </li>
                              <li>
                                <b> Projet </b>
                                <strong className="pull-right">
                                  Projet Vallée Val d’Or 1
                                </strong>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="section-head">
                        <div className="sx-box">
                          <h3 className="m-t0 m-b30">Dossier d’adhésion</h3>
                        </div>
                        <div className="experience  p-t30">
                          <div className="sx-box our-story">
                            <div className="mt-media our-story-info d-flex justify-content-start">
                              <div className="flex flex-auto w-full items-center justify-center">
                                <div className="relative">
                                  <i className="fa fa-file-o"></i>
                                  <div className="absolute left-0 bottom-0 px-6 rounded text-12 font-semibold leading-20 text-white MuiBox-root pdf-icon">
                                    PDF
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="our-story-detail m-t10">
                              <h5 className="">Demande d'adhésion</h5>
                            </div>
                          </div>
                        </div>
                        <div className="experience">
                          <div className="sx-box our-story">
                            <div className="mt-media our-story-info d-flex justify-content-start">
                              <div className="flex flex-auto w-full items-center justify-center">
                                <div className="relative">
                                  <i className="fa fa-file-o"></i>
                                  <div className="absolute left-0 bottom-0 px-6 rounded text-12 font-semibold leading-20 text-white MuiBox-root pdf-icon">
                                    PDF
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="our-story-detail m-t10">
                              <h5 className="">Fiche de renseignement apprt</h5>
                            </div>
                          </div>
                        </div>
                        <div className="experience">
                          <div className="sx-box our-story">
                            <div className="mt-media our-story-info d-flex justify-content-start">
                              <div className="flex flex-auto w-full items-center justify-center">
                                <div className="relative">
                                  <i className="fa fa-file-o"></i>
                                  <div className="absolute left-0 bottom-0 px-6 rounded text-12 font-semibold leading-20 text-white MuiBox-root pdf-icon">
                                    PDF
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="our-story-detail m-t10">
                              <h5 className="">Fiche de renseignement villa</h5>
                            </div>
                          </div>
                        </div>
                        <div className="experience">
                          <div className="sx-box our-story">
                            <div className="mt-media our-story-info d-flex justify-content-start">
                              <div className="flex flex-auto w-full items-center justify-center">
                                <div className="relative">
                                  <i className="fa fa-file-o"></i>
                                  <div className="absolute left-0 bottom-0 px-6 rounded text-12 font-semibold leading-20 text-white MuiBox-root pdf-icon">
                                    PDF
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="our-story-detail m-t10">
                              <h5 className="">Engagement</h5>
                            </div>
                          </div>
                        </div>
                        <div className="experience">
                          <div className="sx-box our-story">
                            <div className="mt-media our-story-info d-flex justify-content-start">
                              <div className="flex flex-auto w-full items-center justify-center">
                                <div className="relative">
                                  <i className="fa fa-file-o"></i>
                                  <div className="absolute left-0 bottom-0 px-6 rounded text-12 font-semibold leading-20 text-white MuiBox-root jpg-icon">
                                    JPG
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="our-story-detail m-t10">
                              <h5 className="">Copie CIN</h5>
                            </div>
                          </div>
                        </div>
                        <div className="experience">
                          <div className="sx-box our-story">
                            <div className="mt-media our-story-info d-flex justify-content-start">
                              <div className="flex flex-auto w-full items-center justify-center">
                                <div className="relative">
                                  <i className="fa fa-file-o"></i>
                                  <div className="absolute left-0 bottom-0 px-6 rounded text-12 font-semibold leading-20 text-white MuiBox-root pdf-icon">
                                    PDF
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="our-story-detail m-t10">
                              <h5 className="">Attestation de Travail</h5>
                            </div>
                          </div>
                        </div>
                        <div className="experience">
                          <div className="sx-box our-story">
                            <div className="mt-media our-story-info d-flex justify-content-start">
                              <div className="flex flex-auto w-full items-center justify-center">
                                <div className="relative">
                                  <i className="fa fa-file-o"></i>
                                  <div className="absolute left-0 bottom-0 px-6 rounded text-12 font-semibold leading-20 text-white MuiBox-root pdf-icon">
                                    PDF
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="our-story-detail m-t10">
                              <h5 className="">Reçu de versement appart</h5>
                            </div>
                          </div>
                        </div>
                        <div className="experience">
                          <div className="sx-box our-story">
                            <div className="mt-media our-story-info d-flex justify-content-start">
                              <div className="flex flex-auto w-full items-center justify-center">
                                <div className="relative">
                                  <i className="fa fa-file-o"></i>
                                  <div className="absolute left-0 bottom-0 px-6 rounded text-12 font-semibold leading-20 text-white MuiBox-root pdf-icon">
                                    PDF
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="our-story-detail m-t10">
                              <h5 className="">Fiche de renseignement apprt</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* ABOUT TEAM MEMBER SECTION END */}
        </div>

        <Footer />
      </>
    );
  }
}

export default TeamDetail;
